import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const ACCENT = '#2B7FFF';

const sections = [
  { title: '1. Acceptance of Terms', body: 'By using Mane, you agree to these Terms of Service. If you do not agree, do not use the platform.' },
  { title: '2. Platform Description', body: 'Mane is a barber booking and business management platform operated by Christian G Flair LLC. We provide tools for barbers to manage appointments, clients, and payments.' },
  { title: '3. User Accounts', body: 'You are responsible for maintaining the security of your account. You must provide accurate information and keep it updated. We reserve the right to suspend accounts for violations.' },
  { title: '4. SMS Messaging', body: 'By providing your phone number you consent to receive transactional and promotional SMS messages. You may opt out at any time by replying STOP. Standard message and data rates may apply.' },
  { title: '5. Payments', body: 'Payment processing is handled by Stripe. We do not store credit card information. Barbers are responsible for their own pricing and services.' },
  { title: '6. No-Show Policy', body: 'Barbers may charge deposits or no-show fees as configured in their settings. Clients agree to these policies when booking.' },
  { title: '7. Limitation of Liability', body: 'Mane is provided "as is." Christian G Flair LLC is not liable for any indirect, incidental, or consequential damages arising from use of the platform.' },
  { title: '8. Intellectual Property', body: 'All software, design, branding, algorithms, and content on this platform are the exclusive property of Christian G Flair LLC and are protected by United States copyright law. You may not copy, reproduce, reverse engineer, scrape, resell, or create derivative works from any part of this platform without express written permission. Unauthorized use may result in civil and criminal liability.' },
  { title: '9. Prohibited Use', body: 'You may not use automated tools, bots, or scrapers to access the platform. You may not attempt to extract business logic, pricing algorithms, or client data. You may not resell access or create competing products derived from Mane. Violations will result in immediate account termination and legal action.' },
  { title: '10. Governing Law', body: 'These terms are governed by the laws of the State of Florida.' },
  { title: '11. Contact', body: 'Christian G Flair LLC · Royal Palm Beach, FL · christiangflairbiz@gmail.com · (561) 888-5567' },
];

export default function Terms() {
  return (
    <div style={{ background: 'transparent', color: '#fff', minHeight: '100vh', fontFamily: 'Inter, sans-serif' }}>
      <Helmet>
        <title>Terms of Service — Mane</title>
        <meta name="description" content="Mane terms of service. Usage terms for the Mane booking platform." />
      </Helmet>
      <div style={{ maxWidth: '760px', margin: '0 auto', padding: '64px 24px 80px' }}>

        {/* Header */}
        <div style={{ marginBottom: '48px', paddingBottom: '32px', borderBottom: '1px solid #1a1a1a' }}>
          <div style={{ color: ACCENT, fontSize: '11px', fontWeight: 700, letterSpacing: '0.18em', textTransform: 'uppercase', marginBottom: '16px' }}>
            MANE
          </div>
          <h1 style={{ fontSize: 'clamp(28px, 5vw, 40px)', fontWeight: 900, letterSpacing: '-0.02em', marginBottom: '8px' }}>
            Terms of Service
          </h1>
          <p style={{ color: '#7A8499', fontSize: '13px' }}>Last updated: March 26, 2026</p>
        </div>

        {/* Sections */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
          {sections.map((s, i) => (
            <div key={i} style={{ paddingBottom: '32px', borderBottom: '1px solid #141414' }}>
              <h2 style={{ color: '#fff', fontSize: '15px', fontWeight: 700, marginBottom: '10px', letterSpacing: '0.01em' }}>{s.title}</h2>
              <p style={{ lineHeight: 1.8, color: '#9CA3B4', fontSize: '14px' }}>{s.body}</p>
            </div>
          ))}
        </div>

        {/* Footer nav */}
        <div style={{ marginTop: '48px', display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
          <Link to="/privacy" style={{ color: ACCENT, fontSize: '13px', fontWeight: 600 }}>Privacy Policy →</Link>
          <Link to="/book" style={{ color: '#7A8499', fontSize: '13px' }}>Book Appointment</Link>
        </div>
      </div>
    </div>
  );
}
